module.exports = __webpack_public_path__ + "img/athena-ava.804550d.png";